import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiLineChartComponent } from '@components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        UiLineChartComponent,
    ],
    exports: [
        UiLineChartComponent,
    ],
})
export class UiLineChartModule { }
